import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../render/render.js";

import {
  RESET as RESET_LEXICON
} from "../lexicon.js";

const createResetTemplate = () => {
  return (
    `<button class="button button_outline button_outline_grey button_filter-reset" style="display: none;">${RESET_LEXICON}</button>`
  );
};
export default class Reset extends Abstract {
  constructor() {
    super();

    this._clickHandler = this._clickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this._element.addEventListener(`click`, this._clickHandler);
  }

  _getTemplate() {
    return createResetTemplate();
  }

  _clickHandler() {
    this._callback.click();
  }
}
